import { useId, type ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function RestrictedMenuItem({
  disabledReason,
  ...props
}: ComponentProps<typeof DropdownMenuItem> & { disabledReason?: string }) {
  const descriptionId = useId();
  if (!disabledReason) return <DropdownMenuItem {...props} />;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <DropdownMenuItem
          {...props}
          aria-disabled="true"
          aria-describedby={descriptionId}
          className={cn("cursor-not-allowed opacity-50", props.className)}
          onSelect={(event) => event.preventDefault()}
        />
      </TooltipTrigger>
      <TooltipContent>
        <p>{disabledReason}</p>
      </TooltipContent>
      <span id={descriptionId} className="sr-only">
        {disabledReason}
      </span>
    </Tooltip>
  );
}
